export const SET_CURRENT_CARDIAC = 'SET_CURRENT_CARDIAC'
export const SET_CARDIAC_LOADING = 'SET_CARDIAC_LOADING'
